// extracted by mini-css-extract-plugin
module.exports = {"search__overlay":"SearchOverlay_search__overlay__aE1qT"};